import { render, staticRenderFns } from "./voluntariado-coordinadores.vue?vue&type=template&id=953fa56a"
import script from "./voluntariado-coordinadores.vue?vue&type=script&lang=js"
export * from "./voluntariado-coordinadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports